import { Resolve, ActivatedRouteSnapshot, Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class EventResolver implements Resolve<any> {
  constructor(private httpClient: HttpClient, private router: Router) {}

  async resolve(route: ActivatedRouteSnapshot) {
    const eventId = parseInt(route.params.id);
    const promises = [
      this.httpClient.get<any>(`${environment.serverPath}/general/isInvited/event/${eventId}`).toPromise(),
      this.httpClient.get<any>(`${environment.serverPath}/events/get-event/${eventId}`).toPromise()
    ];
    const resolvedPromises = await Promise.all(promises);
    if(!resolvedPromises[1].userEvent) {
      this.router.navigate(["/events"]);
    }
    return resolvedPromises
  }
}
